import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Layout from '@/dashboard/admin/layouts/Layout';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';

import { AdminRolesEnum } from '@/dashboard/enums/admin-roles';
import { ADMIN_ROUTES } from '@/dashboard/admin/adminRoutes';

export default function adminRoutes() {
  const { isAuthenticating, isAdmin, user } = useAuth();

  if (!isAuthenticating && !isAdmin) {
    return <Redirect to="/" />;
  }

  return (
    <Layout>
      <Switch>
        {ADMIN_ROUTES.map(({ path, exact, component: Component, roles }) => {
          if (!roles.includes(user.role)) {
            return null;
          }

          return <Route key={path} exact={exact} path={path} component={Component} />;
        })}

        {(user.role === AdminRolesEnum.DEVELOPER || user.role === AdminRolesEnum.EDITOR) && (
          <Redirect exact from="/admin" to="/admin/pages" />
        )}

        {(user.role === AdminRolesEnum.ADMIN || user.role === AdminRolesEnum.SUPPORT) && (
          <Redirect exact from="/admin" to="/admin/merchants" />
        )}
      </Switch>
    </Layout>
  );
}
